import React from 'react';
import { get } from 'lodash';
import { Route, IndexRoute, IndexRedirect, Redirect } from 'react-router';
// Project components
import App from '../components/App';
import Dashboard from '../components/pages/Dashboard';
import About from '../components/About';
import Pages from '../components/pages/Pages';
import Manage from '../components/pages/Manage';
import NavigationPagesComponents from '../components/pages/pages/NavigationPagesComponents';
import NavigateGeneral from '../components/pages/pages/NavigateGeneral';
import NavigationManage from '../components/pages/manage/NavigationManage';
import Theme from '../components/pages/Theme';
import Assets from '../components/assets/Assets';
import NavigationTheme from '../components/pages/theme/NavigationTheme';
import NavigationAssets from '../components/assets/NavigationAssets';
import requireAuthentication from '../components/helpers/requireAuthentication';
import Login from '../components/Login';
import * as pages from '../components/pages/pages/index';
import * as theme from '../components/pages/theme/index';
import * as manage from '../components/pages/manage/index';
import * as assets from '../components/assets/index';
import PageSearchConfig from '../components/pages/pages/search/PageSearchConfig';
import PagesTrackingHooks from '../components/pages/pages/PagesTrackingHooks';
import PagesPolicyUrls from '../components/pages/pages/PagesPolicyUrls';
import InContextTheme from '../components/pages/InContextTheme';
import InContextNavigationTheme from '../components/pages/in-context/SidebarNavigation';
import themeSidebarHelper from '../components/helpers/sidebarHelper';
import ConditionalThemeRoute from '../components/ConditionalThemeRoute';

const ErrorComponent = () => <div>Error.</div>;

const routes = onEnterMainRoute => {
    return (
        <Route>
            <Route
                path="/"
                component={requireAuthentication(App)}
                onEnter={({ location }, replace) => {
                    const token = get(location, 'query.token');
                    const hotelId = get(location, 'query.HotelId');
                    if (token) {
                        sessionStorage.setItem('token', token);
                        sessionStorage.setItem('hotelIdFromCrs', hotelId);
                        return replace('/login');
                    }
                }}
            >
                <IndexRoute component={Dashboard} />
                <Route path="about" component={About} />
                <Route
                    path="pages"
                    components={{ content: Pages, sidebar: NavigationPagesComponents, page: 'children' }}
                    menu="Pages"
                >
                    <Route
                        path="search"
                        components={{ sidebar: NavigationPagesComponents, content: PageSearchConfig, page: 'search' }}
                        component={PageSearchConfig}
                    />
                    <Route
                        path="product/customization"
                        components={{ content: pages.PagesProduct, sidebar: NavigateGeneral }}
                        menu="customization"
                        back="pages"
                    />
                    {/* Redirect "/pages" to "/pages/calendar": */}
                    {/* <IndexRedirect to="calendar" /> */}
                    {/* <Route path="productPage" component={pages.PagesProduct} /> */}
                    <Route path="addOnsPage" component={pages.PagesAddOns} />
                    {/* <Route path="calendar" component={pages.PagesCalendar} /> */}
                    <Route path="rooms-rates" component={pages.PagesRoomsAndRates} />
                    {/* <Route path="add-ons" component={pages.PagesAddOns} /> */}
                    {/* <Route path="cart" component={pages.PagesCart} /> */}
                    {/* <Route path="guest-payment" component={pages.PagesGuestPayment} /> */}
                    <Route path="review" component={pages.PagesReview} />
                    {/* <Route path="confirmation" component={pages.PagesConfirmation} /> */}
                    {/* <Route path="find-res" component={pages.PagesFindRes} /> */}
                    {/* <Route path="modify-res" component={pages.PagesModifyRes} /> */}
                    <Route path="teaser" component={pages.PagesTeaser} />
                    <Route path="side-wide" component={pages.PagesSideWide} />
                    <Route
                        path="customization"
                        components={{ content: pages.PagesProduct, sidebar: NavigateGeneral }}
                        menu="customization"
                    />
                </Route>
                <Route path="pages">
                    <Route
                        path="product"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'product'
                        }}
                        menu="Product"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'rooms' }} />
                        <Route path="labels" components={{ labels: true, itemToShow: 'rooms' }} />
                    </Route>
                    <Route
                        path="product/icons"
                        components={{
                            content: pages.PagesProductIcons,
                            sidebar: NavigationPagesComponents,
                            page: 'product'
                        }}
                        menu="Product"
                        back="pages"
                    />
                    <Route
                        path="addOn"
                        components={{ sidebar: NavigationPagesComponents, content: pages.PagesAddOns, page: 'addOns' }}
                        menu="Add-Ons"
                        back="pages"
                    >
                        <Route path="labels" components={{ itemToShow: 'addOns', labels: true }} />
                    </Route>
                    <Route
                        path="retailProducts"
                        components={{
                            content: pages.PagesRetailProducts,
                            sidebar: NavigationPagesComponents,
                            page: 'retailProducts'
                        }}
                        menu="Retail Products"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'retailProducts' }} />
                    </Route>
                    <Route
                        path="priceSummary"
                        components={{
                            sidebar: NavigationPagesComponents,
                            content: pages.PagesAddOns,
                            page: 'priceSummary'
                        }}
                        menu="Price Summary"
                        back="pages"
                    >
                        <Route path="labels" components={{ itemToShow: 'priceSummary', labels: true }} />
                    </Route>
                    <Route
                        path="signIn"
                        components={{ content: pages.PagesAddOns, sidebar: NavigationPagesComponents, page: 'signIn' }}
                        menu="Sign In"
                        back="pages"
                    >
                        <Route path="labels" components={{ itemToShow: 'signIn', labels: true }} />
                    </Route>
                    <Route
                        path="searchSettings"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'searchSettings'
                        }}
                        menu="Search Settings"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'searchSettings' }} />
                        <Route path="labels" components={{ labels: true, itemToShow: 'searchSettings' }} />
                    </Route>
                    <Route
                        path="globalBar"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'globalBar'
                        }}
                        menu="Global Bar"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'globalBar' }} />
                        <Route path="labels" components={{ labels: true, itemToShow: 'globalBar' }} />
                    </Route>
                    <Route
                        path="filters"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'filters'
                        }}
                        menu="Filters"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'filters' }} />
                        <Route path="labels" components={{ labels: true, itemToShow: 'filters' }} />
                    </Route>
                    <Route
                        path="cart"
                        components={{ content: pages.PagesAddOns, sidebar: NavigationPagesComponents, page: 'cart' }}
                        menu="Checkout"
                        back="pages"
                    >
                        <Route path="labels" components={{ itemToShow: 'cart', labels: true }} />
                    </Route>
                    <Route
                        path="guestPayment"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'guestPayment'
                        }}
                        menu="GUEST & PAYMENT"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'guestInfo' }} />
                        <Route path="labels" components={{ itemToShow: 'guestInfo', labels: true }} />
                    </Route>
                    <Route
                        path="confirmation"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'confirmation'
                        }}
                        menu="Confirmation"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'confirmation' }} />
                        <Route path="labels" components={{ labels: true, itemToShow: 'confirmation' }} />
                    </Route>
                    <Route
                        path="hotel"
                        components={{ content: pages.PagesProduct, sidebar: NavigationPagesComponents, page: 'hotel' }}
                        menu="Hotel"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'hotel' }} />
                        <Route path="menu-content" components={{ itemToShow: 'menuContent' }} />
                        <Route path="labels" components={{ labels: true, itemToShow: 'hotel' }} />
                    </Route>
                    <Route
                        path="general/tracking-hooks"
                        components={{
                            content: PagesTrackingHooks,
                            sidebar: NavigationPagesComponents,
                            page: 'general'
                        }}
                        menu="General"
                        back="pages"
                    />
                    <Route
                        path="general/policy-urls"
                        components={{ content: PagesPolicyUrls, sidebar: NavigationPagesComponents, page: 'general' }}
                        menu="General"
                        back="pages"
                    />
                    <Route
                        path="general"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'general'
                        }}
                        menu="General"
                        back="pages"
                    >
                        <Route path="settings" components={{ itemToShow: 'general' }} />
                        <Route path="labels" components={{ labels: true, itemToShow: 'general' }} />
                    </Route>
                    <Route
                        path="widgets"
                        components={{ sidebar: NavigationPagesComponents, content: pages.PagesAddOns, page: 'widgets' }}
                        menu="Widgets"
                        back="pages"
                    >
                        <Route path="labels" components={{ itemToShow: 'widgets', labels: true }} />
                    </Route>
                    <Route
                        path="customContent"
                        components={{
                            content: pages.PagesCustomContent,
                            sidebar: NavigationPagesComponents,
                            page: 'customContent'
                        }}
                        menu="Custom Content"
                        back="pages"
                    >
                        <Route path="custom-content" components={{ itemToShow: 'customContent' }} />
                    </Route>
                    {/* not used? */}
                    <Route
                        path="confirmationSettings"
                        components={{
                            content: pages.PagesProduct,
                            sidebar: NavigationPagesComponents,
                            page: 'confirmation'
                        }}
                        menu="confirmation"
                        back="pages"
                    />
                    <Route
                        path="find-res"
                        components={{ content: pages.PagesFindRes, sidebar: NavigateGeneral }}
                        menu="findRes"
                        back="pages"
                    />
                    <Route
                        path="modify-res"
                        components={{ content: pages.PagesModifyRes, sidebar: NavigateGeneral }}
                        menu="searchRes"
                        back="pages"
                    />
                </Route>
                <Route path="manage" components={{ content: Manage, sidebar: NavigationManage }}>
                    <IndexRedirect to="manage-theme" />
                    <Route path="manage-theme" component={manage.ManageTheme} />
                    <Route path="manage-theme/edit-theme" component={manage.EditTheme} />
                    <Route path="manage-configuration" component={manage.ManageConfiguration} />
                    <Route path="manage-configuration/edit-configuration" component={manage.EditConfig} />
                    <Route path="apps" component={manage.ManageApps} />
                    <Route path="domains" component={manage.ManageDomains} />
                </Route>
                <Route path="theme" components={{ content: Theme, sidebar: themeSidebarHelper(App) }}>
                    <Route path="colors" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeColors} />} />
                    {/* <Route path="images" component={theme.ThemeImages} /> */}
                    <Route path="buttons" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeButtons} />} />
                    <Route path="calendar" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeCalendar} />} />
                    <Route path="gallery" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeGallery} />} />
                    <Route path="card" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeCard} />} />
                    <Route path="form" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeForm} />} />
                    <Route path="global" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeGlobal} />} />
                    <Route path="filter-bar" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeFilterBar} />} />
                    <Route path="header" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.ThemeHeader} />} />
                    <Route path="customContent" component={(props) => <ConditionalThemeRoute {...props} ThemeComponent={theme.CustomContent} />} />
                </Route>
                <Route path="assets" components={{ content: Assets, sidebar: NavigationAssets }}>
                    <Route path="images" component={assets.PagesImages} />
                    {/* <Route path="videos" component={assets.PagesVideos} /> */}
                    <Route path="customization" component={assets.PagesCustomization} />
                    <Route path="tracking" component={assets.PagesTracking} />
                    <Route path="customFonts" component={assets.PagesCustomFonts} />
                    <Route path="other" component={assets.PagesOther} />
                </Route>
            </Route>
            <Route path="_test">
                <Route path="protected" component={Login} />
            </Route>
            {/* <Route path="login" component={Authentication} /> */}
            <Route
                path="login"
                component={Login}
                onEnter={({ location }, replace) => {
                    const token = get(location, 'query.token');
                    const hotelId = get(location, 'query.HotelId');
                    if (token) {
                        sessionStorage.setItem('token', token);
                        sessionStorage.setItem('hotelIdFromCrs', hotelId);
                        return replace('/login');
                    }
                }}
            />
            <Route path="error" component={ErrorComponent} />
            {/* Redirect every unknown route to "/": */}
            <Redirect from="*" to="/" />
        </Route>
    );
};

export default routes;



// WEBPACK FOOTER //
// ./src/config/Routes.js